import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "helpers/url_helper";
import { get, post, del, put } from "helpers/api_helper";
import { toast } from "react-toastify";
export const getRoomList = createAsyncThunk(
  "getRoomList",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_ROOM_LIST, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
export const addRoom = createAsyncThunk(
  "addRoom",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.ADD_ROOM, data);
      console.log("response-->", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const editRoom = createAsyncThunk(
  "editRoom",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.EDIT_ROOM, data);
      console.log("response-->", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const getCategoryList = createAsyncThunk(
  "getCategoryList",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_CATEGORY_LIST, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
export const addCategory = createAsyncThunk(
  "addCategory",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.ADD_CATEGORY, data);
      console.log("response-->", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const getMessageList = createAsyncThunk(
  "getMessageList",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_ROOM_MESSAGES, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const ediCategory = createAsyncThunk(
  "ediCategory",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.EDIT_CATEGORY, data);
      console.log("response-->", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error?.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const getCategoryListAll = createAsyncThunk(
  "getCategoryListAll",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_CATEGORY_LIST_ALL, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
